import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import styles from './sitemap.module.scss';
import { useState, useEffect } from 'react';

interface SitemapNode {
  path: string;
  title: string;
  children?: SitemapNode[];
}

interface SiteMapComponentProps {
  groupedRoutes: SitemapNode[];
}

const SiteMapComponent = ({ groupedRoutes }: SiteMapComponentProps) => {
  const TABLET_POINT = 1200;

  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkSize = () => setIsTablet(window.innerWidth <= TABLET_POINT);
    checkSize();
    window.addEventListener('resize', checkSize);
    return () => window.removeEventListener('resize', checkSize);
  }, []);

  const firstTwo = groupedRoutes.slice(0, isTablet ? 3 : 2);
  const rest = groupedRoutes.slice(isTablet ? 3 : 2);
  return (
    <>
      <Breadcrumbs />
      <section className={styles.section}>
        <div className={styles.sitemap__wrapper}>
          <h1>Sitemap</h1>
          <div className={styles.sitemap__wrapper__columns}>
            <div className={styles.sitemap__wrapper__column__group}>
              {firstTwo.map((section) => (
                <div key={section.path} className={styles.sitemap__wrapper__column}>
                  <h2 className={styles.sitemap__wrapper__column__title}>
                    <a href={section.path}>{section.title}</a>
                  </h2>
                  {section.children?.length ? (
                    <div className={styles.sitemap__wrapper__column__child}>
                      {section.children.map((child) => (
                        <div key={child.path} className={styles.sitemap__wrapper__column__child__title}>
                          <a href={child.path}>{child.title}</a>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>

            {isTablet ? (
              <div className={`${styles.sitemap__wrapper__column__group} ${styles.tabletGroup}`}>
                {rest.map((section) => (
                  <div key={section.path} className={styles.sitemap__wrapper__column}>
                    <h2 className={styles.sitemap__wrapper__column__title}>
                      <a href={section.path}>{section.title}</a>
                    </h2>
                    {section.children?.length ? (
                      <div className={styles.sitemap__wrapper__column__child}>
                        {section.children.map((child) => (
                          <div key={child.path} className={styles.sitemap__wrapper__column__child__title}>
                            <a href={child.path}>{child.title}</a>
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
            ) : (
              rest.map((section) => (
                <div key={section.path} className={styles.sitemap__wrapper__column}>
                  <h2 className={styles.sitemap__wrapper__column__title}>
                    <a href={section.path}>{section.title}</a>
                  </h2>
                  {section.children?.length ? (
                    <div className={styles.sitemap__wrapper__column__child}>
                      {section.children.map((child) => (
                        <div key={child.path} className={styles.sitemap__wrapper__column__child__title}>
                          <a href={child.path}>{child.title}</a>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SiteMapComponent;
